<template>
  <div class="index">
    <el-row class="row-box">
      <el-col :span="10" class="left">
        <div style="text-align:left">
          <el-button type="primary" @click="selectCourses" size="medium" style="margin-top:10px;margin-left:10px">选择课程目录</el-button>
        </div>
        <div class="block">
        <!-- :default-checked-keys="[data[0].id]" -->
        <!-- :current-node-key="currentNodeKey"  -->
        <el-tree
        ref="tree"
        :data="data"
        node-key="id"
        :highlight-current="true"
        :current-node-key="currentNodeKey"
        :expand-on-click-node="false"
        :check-on-click-node="true"
        :indent="30"
        :filter-node-method="filterNode"
        :accordion="true"
        @node-click="nodeClick"
        :props="{
          label: 'name',
          children: 'subList'
        }"
      >
        <div class="custom-tree-node" slot-scope="{ node, data }">
          <div style="display: flex">
            <span class="level-path">{{data.levelPath}}</span>
            <span style="margin-left: 5px;display: inline-block;">{{data.name}}</span>
          </div>
          <span style="margin-left:20px;margin-top: 5px;">
            <el-button type="text" size="mini" @click.stop="() => edit(data, node)">编辑</el-button>
          </span>
        </div>
      </el-tree>
      </div>
      </el-col>
      <el-col :span="14" class="right" v-loading="loading">
        <div class="block">
          <tab-button
          :showAll="false"
          :tabs="baseMenu"
          :label="'题目类型'"
          :prop="'type'"
          :initialTab="1"
          @tab-change="onTabChange"
        />
        <el-button icon="" type="text" size="medium" @click="getRightData(directoryId)">刷新</el-button>
        </div>
        <div class="context">
          <p class="text">资源信息</p>
          <question v-if="type==1" :questions="questions" @update="getRightData(directoryId)" :isEdit="isEdit" />
          <vedio v-if="type==2" :vedios="vedios" @update="getRightData(directoryId)" :videoUrl="videoUrl" :isEdit="isEdit" />
          <courseware ref="courseware" v-if="type==3" :coursewares="coursewares" @update="getRightData(directoryId)" :coursewareUrl="coursewareUrl" :isEdit="isEdit" />
          <casebox v-if="type==4" :cases="cases" @update="getRightData(directoryId)" :isEdit="isEdit" />
        </div>
      </el-col>
    </el-row>
    <Dialog
      v-model="dialogdetail" :width="'70%'"
      :title="'选择课程目录'" :footer="true" :showClose="false"
      @confirm="handleConfirm"
    >
      <template slot="dialog-content">
        <tree ref="tree" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { courseServer, packgeServer } from '@/api/api'
import { baseMenu } from '@/data/data';
import tabButton from '@/mixin/table.js';
import Dialog from '@/components/common/Dialog';
import question from './components/question.vue'
import vedio from './components/vedio.vue'
import courseware from './components/courseware.vue'
import casebox from './components/casebox.vue'
// import tree from './components/tree.vue'
export default {
  mixins: [tabButton],
  components: {Dialog, question, vedio, courseware, casebox},
  data () {
    const data = [];
    return {
      baseMenu,
      loading: false,
      dialogdetail: false,
      data: JSON.parse(JSON.stringify(data)),
      directoryId: null,
      currentNodeKey: null,
      questions: [],
      vedios: [],
      videoUrl: {},
      coursewares: [],
      coursewareUrl: {},
      cases: [],
      isEdit: false,
      type: 1
    }
  },
  created () {
    this.selectData()
    this.selectCourses()
  },
  methods: {
    selectCourses () {
      this.dialogdetail = true
      this.$nextTick(() => {
        this.$refs.tree.selectData()
      })
    },
    questionData (directoryId) {
      this.loading = true
      packgeServer.questions({
        directoryId
      }).then(res => {
        const {code, data, message} = res
        this.loading = false
        if (code === '0') {
          data.forEach(v => {
            if (v.type !== 3 || v.type !== 5) v.options = JSON.parse(v.options)
            if (v.type === 5) v.answer = JSON.parse(v.answer)
          })
          this.questions = data
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    vedioData (directoryId) {
      this.loading = true
      packgeServer.vedios({
        directoryId
      }).then(res => {
        const {code, data, message} = res
        this.loading = false
        if (code === '0') {
          this.vedios = data
          const filePath = data.map(v => v.filePath).join()
          this.getfileurl(filePath)
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    coursewareData (directoryId) {
      this.loading = true
      packgeServer.coursewares({
        directoryId
      }).then(res => {
        const {code, data, message} = res
        this.loading = false
        if (code === '0') {
          this.coursewares = data
          const filePath = data.map(v => v.filePath).join()
          this.getfileurl(filePath)
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    caseData (directoryId) {
      this.loading = true
      packgeServer.cases({
        directoryId
      }).then(res => {
        const {code, data, message} = res
        this.loading = false
        if (code === '0') {
          this.cases = data
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    getRightData (directoryId) {
      if (this.type === 1) {
        this.questionData(directoryId)
      }
      if (this.type === 2) {
        this.vedioData(directoryId)
      }
      if (this.type === 3) {
        this.coursewareData(directoryId)
      }
      if (this.type === 4) {
        this.caseData(directoryId)
      }
    },
    nodeClick (data, node, current) {
      this.directoryId = data.id
      this.isEdit = false
      this.getRightData(data.id)
    },
    edit (data, node) {
      this.isEdit = true
    },
    // 处理 tab 切换事件
    onTabChange({tab, prop}) {
      this[prop] = tab
      this.getRightData(this.directoryId)
      // 这里可以根据不同的 tab 索引进行相应的操作
    },
    selectData () {
      courseServer.profressionDirectory().then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.data = data
          if (data.length) {
            this.directoryId = data[0].id
            this.currentNodeKey = data[0].id
            this.$nextTick(() => {
              this.$refs['tree'].setCurrentKey(this.currentNodeKey)
            })
            this.getRightData(this.directoryId)
          }
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    // 弹窗确认的回调
    handleConfirm() {
      this.dialogdetail = false
    },
    getfileurl (fileKeys) {
      this.$getUrl({
      fileKeys
      }).then(obj => {
        if (obj) {
          if (this.type === 2) {
            this.videoUrl = obj
          }
          if (this.type === 3) {
            this.coursewareUrl = obj
          }
        }
      })
    },
    filterNode (value, data) {
      return !data.delete;
    }
  }
}
</script>

<style lang='scss' scoped>
.index {
  margin: 0 10px;
}
.row-box {
  display: flex;
  align-self: baseline;
}
.left {
  margin-right: 20px;
  max-height: calc(100vh - 70px);
  overflow: auto;
}
.left, .right {
  background: #fff;
  overflow: auto;
}
.block {
  padding: 10px;
  // height: 100%;
  // align-self: baseline;
  display: flex;
  justify-content: space-between;
  padding-right: 20px;
  .custom-tree-node {
    width: 100%;
    display: flex;
    align-items: baseline;
    text-align: left;
  }
  .level-path {
    display: inline-block;
    align-self: center;
    // width: 20px;
  }
}
.context {
  padding: 10px 30px;
  max-height: calc(100vh - 140px);
  overflow: auto;
  .text {
    text-align: left;
    font-weight: 600;
    font-size: 16px;
  }
}

</style>
<style lang='scss'>
.block .el-tree {
  width: 100%;
}
.block .el-tree .el-tree-node {
  white-space: normal !important;
  line-height: 20px;
  // overflow: hidden;
  // text-overflow: ellipsis;
}
.el-tree-node,
.el-tree-node__content {
  margin-bottom: 5px;
  min-height: 50px;
  // max-height: 65px;
  height: auto;
  border-radius: 6px;
}
.el-icon-caret-right{
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/views/coursePackage/medicalTechnology.vue